// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1NNJZ","list":"BalanceDue_list__3Wuxn","listRow":"BalanceDue_listRow__2v_Fx","total":"BalanceDue_total__Ct0eQ"};